import { PaletteHelpers } from '@pratt/js/utils/palette-helpers';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const TIME_ZONE = 'America/New_York';

export class HitHelpers {
  static getTypeDisplay(type) {
    switch (type) {
      case 'post':
        return 'News';
      case 'prattfolio-story':
        return 'Prattfolio Story';
      default:
        return type[0].toLocaleUpperCase() + type.slice(1);
    }
  }

  static Courses = {
    sectionsAsHtml(hit) {
      return `
        <ul class="course-hit__section-list">
          ${hit.sections.map(section => `
            <li class="course-hit__section-item">
              <span class="course-hit__section-days">${section.days.join(', ')}</span>
              <span class="course-hit__section-time">${section.start_time} – ${section.end_time}</span>
              <span class="course-hit__section-location">${section.location ? section.location.map(loc => loc.name).join(', ') : ''}</span>
            </li>
          `).join('')}
        </ul>
      `;
    },
  };

  static Events = {
    dateAsHTML(hit) {
      const start = new Date(
        new Date(hit.occurrences[0].start).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );
      return `
        <time class="event-hit__date" datetime="${start.toLocaleString()}">
          <span class="event-hit__date-month">${MONTHS[start.getMonth()]}</span>
          <span class="event-hit__date-day">${start.getDate()}</span>
        </time>
      `;
    },

    time(hit, opts = {}) {
      if (!hit.occurrences.length) {
        return '';
      }

      const start = new Date(
        new Date(hit.occurrences[0].start).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );
      const end = new Date(
        new Date(hit.occurrences[0].end).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );

      const timeFormat = new Intl.DateTimeFormat('en-US', { timeStyle: 'short' });
      const dateFormat = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      const dateFormatNoYear = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' });

      const isSameDay =
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate();

      const isSameYear = start.getFullYear() === end.getFullYear();

      let time;
      if (hit.is_all_day) {
        if (isSameDay) {
          time = 'All Day';
          if (opts.includeDay) {
            time = dateFormat.format(start);
          }
        } else {
          if (isSameYear) {
            time = `<span>${dateFormatNoYear.format(start)} – ${dateFormat.format(
              end,
            )}</span> <span>All Day</span>`;
          } else {
            time = `<span>${dateFormat.format(start)} – ${dateFormat.format(
              end,
            )}</span> <span>All Day</span>`;
          }
        }
      } else {
        if (isSameDay) {
          time = `${timeFormat.format(start)} – ${timeFormat.format(end)}`;
          if (opts.includeDay) {
            time = `<span>${dateFormat.format(start)}</span> <span>${time}</span>`;
          }
        } else {
          let startDateDay = `${dateFormat.format(start)}`;
          if (isSameYear) {
            startDateDay = `${dateFormatNoYear.format(start)}`;
          }
          const endDateDay = `${dateFormat.format(end)}`;
          const startDateTime = `${timeFormat.format(start)}`;
          const endDateTime = `${timeFormat.format(end)}`;
          time = `<span>${startDateDay} – ${endDateDay}</span> <span>${startDateTime} – ${endDateTime}</span>`;
        }
      }

      return time;
    },

    location(hit) {
      if (hit.event_type === 'hybrid') {
        return `Online and ${hit.location}`;
      } else if (hit.event_type === 'physical') {
        return hit.location;
      } else {
        return 'Online Event';
      }
    },

    hitCallouts(hit) {
      if (!hit.primary_term) return '';
      return `<div class="event-hit__callout">${hit.primary_term}</div>`;
    },

    hitGradient(rank = 'tertiary', angle = null, bland = false) {
      return PaletteHelpers.getRandomGradient(rank, angle, bland);
    }
  };
}
